(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CouponListController', CouponListController);

    CouponListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'Coupon', 'CouponCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService'];

    function CouponListController($scope, $state, ParseLinks, AlertService, Coupon, CouponCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService) {


        var vm = this;


        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.newCouponClick = newCouponClick;
        vm.searchKeyPress = searchKeyPress;


        vm.editCoupon = editCoupon;
        vm.searchCoupons = search;
        vm.searchKeyPress = searchKeyPress;
        vm.newCoupon = newCoupon;
        vm.clearSearch = clearSearch;
        vm.deleteCoupon = deleteCoupon;


        loadAll_paging();

        function loadAll_paging() {


            if (pagingParams.search) {
                CouponCustom.getAllCompanyCoupons().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CouponCustom.getAllCompanyCoupons().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {

                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.coupons = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function search() {

            loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();

        }

        function newCouponClick() {

            var result;

            result = Principal.hasSpecialFeatureAccess("couponCode");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.transitionTo('supplierPanel.newCoupon');

        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function editCoupon(coupon) {
            $state.go('supplierPanel-v2.editCoupon', {id: coupon.id});
        }

        function newCoupon() {
            var result;

            result = Principal.hasSpecialFeatureAccess("couponCode");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }
            $state.go('supplierPanel-v2.newCoupon');
        }

        function clearSearch() {
            vm.searchQuery = null;
            search();
        }

        function deleteCoupon(coupon) {
           Coupon.delete(coupon, onDeleteSuccess);
        }

        function onDeleteSuccess(res) {
            loadAll_paging()
        }
    }
})();
